import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

export const ScanIcon: React.FC<IconProps> = props => {
  return (
    <Icon boxSize={6} color="teal.600" {...props}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 7V5a2 2 0 0 1 2-2h2M21 7V5a2 2 0 0 0-2-2h-2M3 17v2a2 2 0 0 0 2 2h2M21 17v2a2 2 0 0 1-2 2h-2" />
        <rect x="7" y="7" width="10" height="10" rx="1" />
        <path d="M9 9h6M9 12h6M9 15h6" />
      </svg>
    </Icon>
  );
};

export const ChargeIcon: React.FC<IconProps> = props => {
  return (
    <Icon boxSize={6} color="green.600" {...props}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v12M15 9l-3-3-3 3" />
      </svg>
    </Icon>
  );
};

export const DisplayIcon: React.FC<IconProps> = props => {
  return (
    <Icon boxSize={6} color="purple.600" {...props}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="5" y="5" width="14" height="14" rx="2" />
        <path d="M8 8h2v2H8zM14 8h2v2h-2zM8 14h2v2H8z" />
        <path d="M14 14h1M17 14h1M14 17h1M17 17h1" />
      </svg>
    </Icon>
  );
};

export const DefaultIcon: React.FC<IconProps> = props => {
  return (
    <Icon boxSize={6} color="gray.500" {...props}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
      </svg>
    </Icon>
  );
};
